class EvaluationController {
}

export default EvaluationController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/evaluationController.js